import {
  APP_ID,
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { redirectRoutes, routes } from './app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from '../environments/environment';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import packageJson from '../../package.json';
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MomentDateAdapter,
} from '@angular/material-moment-adapter';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import { CUSTOM_DATE_FORMATS } from './shared/constants/custom-date-formats';
import { MAT_PAGINATOR_DEFAULT_OPTIONS } from '@angular/material/paginator';
import { JwtInterceptor } from './services/auth/jwt.interceptor';
import { GlobalHttpInterceptorService } from './services/http/global-http-interceptor.service';
import { GlobalErrorHandler } from './services/errors/error-handler.service';
import { STORAGE_NAMES } from '@app-shared/constants/constants';
import { provideUiTour } from 'ngx-ui-tour-md-menu';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection(),
    { provide: APP_ID, useValue: 'client-app' },
    provideUiTour(),
    provideRouter([...redirectRoutes, ...routes]),
    ...provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(
      TranslateModule.forRoot({
        fallbackLang: environment.language,
        lang: environment.language,
      })
    ),
    ...provideTranslateHttpLoader({
      prefix: '/assets/i18n/',
      suffix: `.json?v=${encodeURIComponent(packageJson.version)}`,
    }),
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
    {
      provide: MAT_DATE_LOCALE,
      useValue: localStorage.getItem(STORAGE_NAMES.USER_LOCALE),
    },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
    {
      provide: MAT_PAGINATOR_DEFAULT_OPTIONS,
      useValue: { formFieldAppearance: 'fill' },
    },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: GlobalHttpInterceptorService,
      multi: true,
    },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
  ],
};
